// src/pages/admin/Resenas.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function Resenas() {
  const [pendientes, setPendientes] = useState([]);
  useEffect(() => { api.get('/resenas/pendientes').then(r => setPendientes(r.data)).catch(()=>{}); }, []);

  const aprobar = async (id) => {
    await api.put(`/resenas/${id}/aprobar`);
    toast.success('Reseña aprobada ✅');
    setPendientes(p => p.filter(r => r.id !== id));
  };

  const stars = n => '★'.repeat(n) + '☆'.repeat(5-n);

  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', position:'sticky', top:0, zIndex:10 }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Reseñas pendientes ({pendientes.length})</h1>
      </div>
      <div style={{ padding:'24px 28px' }}>
        {pendientes.length === 0 ? (
          <div style={{ textAlign:'center', padding:60, color:'var(--text-muted)' }}>
            <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
            <div style={{ fontSize:16, fontWeight:700 }}>No hay reseñas pendientes</div>
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {pendientes.map(r => (
              <div key={r.id} className="card">
                <div className="card-body">
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                    <div>
                      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
                        <span style={{ fontWeight:800 }}>{r.nombre_cliente}</span>
                        <span style={{ color:'var(--yellow)', fontSize:16 }}>{stars(r.calificacion)}</span>
                      </div>
                      <div style={{ fontSize:12, color:'var(--green)', fontWeight:700, marginBottom:6 }}>{r.producto_nombre}</div>
                      <p style={{ fontSize:14, color:'var(--text-muted)', lineHeight:1.6 }}>{r.comentario}</p>
                      <div style={{ fontSize:11, color:'var(--text-muted)', marginTop:6 }}>{new Date(r.created_at).toLocaleDateString('es-CO')}</div>
                    </div>
                    <div style={{ display:'flex', gap:8, marginLeft:20 }}>
                      <button className="btn btn-primary btn-sm" onClick={() => aprobar(r.id)}>✅ Aprobar</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
